import { Reveal, SectionHeading } from "./Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "Mastery in Motion & Excavation",
    text: "From rough clearing to laser-accurate final grading, we sculpt terrain with heavy iron precision and surgical care.",
    span: "lg:col-span-2",
  },
  {
    number: "02",
    title: "The Hydroseeding Chemistry",
    text: "Premium seed, wood fiber mulch, tackifiers, and root inoculants — a custom slurry built for germination up to 3x faster than straw and broadcast seed.",
    span: "",
  },
  {
    number: "03",
    title: "Uncompromised Tennessee Grit",
    text: "Owner-operated with 100% direct accountability. When you call 423-748-2012, you speak to the man standing on your site — not a call center.",
    span: "lg:col-span-3",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="border-y border-[#122e21] bg-[#16382a]"
    >
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-32 lg:px-16">
        <SectionHeading
          overline="02 / Why us"
          title="Why Pratt's"
          testid="manifesto-heading"
          dark
        />
        <div className="grid gap-6 lg:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.number} delay={0.12 * i} className={c.span}>
              <article
                data-testid={`manifesto-chapter-${c.number}`}
                className="flex h-full flex-col justify-between rounded-md border border-[#f6f1e3]/15 bg-[#1c4431]/60 p-8 transition-transform duration-300 hover:-translate-y-2 md:p-10"
              >
                <span className="text-outline font-display text-6xl font-extrabold leading-none md:text-7xl">
                  {c.number}
                </span>
                <div className="mt-10">
                  <h3 className="font-display text-xl font-bold tracking-tight text-[#f6f1e3] sm:text-2xl">
                    {c.title}
                  </h3>
                  <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#c3d2bd]">
                    {c.text}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
